import { render, staticRenderFns } from "./createABadgeEvent.vue?vue&type=template&id=a4ccdff4&scoped=true&"
import script from "./createABadgeEvent.vue?vue&type=script&lang=js&"
export * from "./createABadgeEvent.vue?vue&type=script&lang=js&"
import style0 from "./createABadgeEvent.vue?vue&type=style&index=0&lang=css&"
import style1 from "./createABadgeEvent.vue?vue&type=style&index=1&id=a4ccdff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ccdff4",
  null
  
)

component.options.__file = "createABadgeEvent.vue"
export default component.exports